module.exports = __webpack_public_path__ + "static/coffeeIcon-b0ba486e5ff35aa61ca7796ef411f069.svg";